'use client';
import type { StoreApi, UseBoundStore } from 'zustand';
import { persist } from 'zustand/middleware';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface FundingDevtoolsState {
  preferences: Record<string, boolean>;
  setLocationOverride(owner: string, enabled: boolean): void;
}
export const useFundingDevtoolsStore: UseBoundStore<StoreApi<FundingDevtoolsState>> =
  createTrackedStore<FundingDevtoolsState>('useFundingDevtoolsStore')(
    persist(
      (set) => ({
        preferences: {},
        setLocationOverride: (owner: string, enabled: boolean): void => {
          set((state) => ({ preferences: { ...state.preferences, [owner]: enabled } }));
        },
      }),
      {
        name: 'funding-devtools',
        partialize: (state: FundingDevtoolsState) => ({ preferences: state.preferences }),
      },
    ),
  );
